// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"b2231506","236":"bdc1ea39","329":"9dcc3ccc","564":"4c8bf6c3","644":"b2231506"}[chunkId] + ".chunk.css";
};